export default __webpack_public_path__ + "static/exit_light_b.7863b2211dc324d747c2bbc8fc6a5611.png";